module.exports = __webpack_public_path__ + "static/media/MapMarkerRed.f7a96f43.svg";